import { useRouter } from 'next/router'
import qs from 'qs'
import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import CollectionOverview from '../../components/collectionoverview/CollectionOverview'
import Page from '../../components/page/Page'
import { Context } from '../../components/waxplorer/Waxplorer'
import config from '../../config.json'

const CollectionsPage = (props) => {
    const subPage = props['subPage']

    let values =
        typeof window !== 'undefined'
            ? useMemo(() => {
                  return qs.parse(
                      window.location.search.substring(
                          1,
                          window.location.search.length,
                      ),
                  )
              }, [])
            : []

    const router = useRouter()

    const setQueryStringWithoutPageReloadPush = useCallback(
        (qsValue) => {
            const newPath = window.location.pathname + '?' + qsValue

            router.push(newPath, undefined, { shallow: true })
        },
        [router],
    )

    const keyLimits = {
        collections: 40,
        sets: 40,
        assets: 60,
        templates: 60,
        users: 40,
    }

    const [state, dispatch] = useContext(Context)

    const { t } = useTranslation('common')

    const [tabKey, setTabKey] = useState(
        typeof window !== 'undefined'
            ? values['tab'] && values['tab'] in keyLimits
                ? values['tab']
                : 'collections'
            : props.tab && props.tab in keyLimits
            ? props.tab
            : 'collections',
    )

    const GetAssets = useCallback(
        async (key, initial = false) => {
            if (key !== tabKey || initial) {
                if (key === 'collections') {
                } else if (key === 'assets') {
                    dispatch({ type: 'SET_SWITCHED_TAB', payload: true })
                }

                const query = values

                delete query['order_dir']
                delete query['search_type']
                delete query['order_by']
                query['tab'] = key
                delete query['offer_type']

                if (!initial)
                    setQueryStringWithoutPageReloadPush(qs.stringify(query))
                setTabKey(key)
            }
        },
        [dispatch, setQueryStringWithoutPageReloadPush, tabKey, values],
    )

    useEffect(() => {
        if (typeof window !== 'undefined') GetAssets(tabKey, true)
    }, [GetAssets, tabKey])

    const image = 'https://www.nfthive.io/nfthive-logo.png'

    const getPageTitle = (tab) => {
        switch (tab) {
            case 'assets':
                return config.titles.explorer.assets
            case 'collections':
                return config.titles.explorer.collections
            case 'users':
                return config.titles.explorer.users
            case 'sets':
                return config.titles.explorer.sets
            default:
                return config.titles.main
        }
    }

    const getPageDescription = (tab) => {
        switch (tab) {
            case 'assets':
                return config.descriptions.explorer.assets
            case 'collections':
                return config.descriptions.explorer.collections
            case 'users':
                return config.descriptions.explorer.users
            case 'sets':
                return config.descriptions.explorer.sets
            default:
                return config.descriptions.main
        }
    }

    const pageTitle = getPageTitle(tabKey)
    const pageDescription = getPageDescription(tabKey)

    return (
        <Page
            id={'CollectionOverviewPage'}
            title={pageTitle}
            description={pageDescription}
            image={image}
            breadCrumbs={[{ href: '', title: t('navigation.collections') }]}
            {...props}
            pageTitle={t('pages.explore_collections')}
            pageSubtitle={t('pages.step_into_the_world_of_collections')}
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Collections',
                    link: '/collections',
                },
            ]}
        >
            <CollectionOverview {...props} subPage={subPage} />
        </Page>
    )
}

CollectionsPage.getInitialProps = async (ctx) => {
    const paths = ctx.asPath.split('/')

    return qs.parse(paths[paths.length - 1].replace('collections?', ''))
}

export default CollectionsPage
